/**
 * 内置UI服务名称
 * @beta
 */
var ServiceNames;
(function (ServiceNames) {
    ServiceNames["CONTEXT_MENU"] = "context_menu";
    ServiceNames["MOBILE_CONTEXT_MENU"] = "mobile_context_menu";
    ServiceNames["MENU"] = "menu";
    ServiceNames["MOBILE_MENU"] = "mobile_menu";
    ServiceNames["TOOLBAR"] = "toolbar";
    ServiceNames["MOBILE_TOOLBAR"] = "mobile_toolbar";
    ServiceNames["STATUSBAR"] = "statusbar";
    ServiceNames["TITLEBAR"] = "titlebar";
    ServiceNames["MOBILE_TITLEBAR"] = "mobile_titlebar";
    ServiceNames["KEYMAP"] = "keymap";
    ServiceNames["FLOAT_WIDGET"] = "float_widget";
    ServiceNames["EMBED_WIDGET"] = "embed_widget";
    ServiceNames["WRAPPED_WIDGET"] = "wrapped_widget";
    ServiceNames["MOBILE_ACTION_BUTTON"] = "mobile_action_buttons";
})(ServiceNames || (ServiceNames = {}));

export { ServiceNames };
//# sourceMappingURL=service-name.js.map
